<template>
  <div
    v-if="fields"
    :class="{ 'text-banner-wrapper': !fields.divider || fields.divider !== 'yellow triangle' }"
  >
    <div class="content-center">
      <div class="content-constraint">
        <div class="text-banner-content">
          <h1 class="secondary--text">
            {{ fields.heading }}
          </h1>
          <ctf-rich-text :document="fields.subHeading" />
        </div>
      </div>
    </div>
    <div
      v-if="fields.divider === 'orange bar'"
      class="pos-abs orange-bar"
    />
    <div
      v-if="fields.divider === 'yellow triangle'"
      class="pos-abs yellow-triangle"
    />
  </div>
</template>

<script>

export default {
  name: 'TextBanner',
  props: {
    fields: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/styles/variables';
  .text-banner-wrapper {
    margin-bottom: 35px;
  }
  .text-banner-content {
    max-width: 598px;
    margin: 55px 0;
  }
  .orange-bar {
    right: 0;
    margin-right: -8px;
    width: 62%;
    height: 8px;
    border-radius: 100px;
    background-color: $yellow;
  }
  .yellow-triangle {
    max-width: 711px;
    max-height: 84px;
    width: 62%;
    height: 100%;
    right: 0;
    margin-top: -84px;
    z-index: -1;
    background-image: url("/assets/img/yellow-triangle.jpg");
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
  }
</style>
